module.exports = __webpack_public_path__ + "static/img/product_banner_26_zh.d2435cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_26_zh.png
// module id = YPyD
// module chunks = 34